export default "__VITE_ASSET__BrvVS2wp__ 1200w";